module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-151.702e1988.svg";